<div class="container">
  <div class="row">
  <div class="staticPages">

  <div data-language="bg"  *ngIf="selectedLang === 'bg'">
    <h1>Възможности за реклама &#64; Zavedenia.bg</h1>
    <h2>Платена реклама за цялостно представяне на ресторанти, барове, клубове</h2>

    <p>Допълнителна реклама на сайта, извън абонаментните планове, може да увеличи потока на посетители към профила Ви и потенциални клиенти в заведението Ви.<br>
      Ще съдействаме да изготвим подходящата маркетинг стратегия за конкретен повод или тип заведение. Дългогодишният ни опит в бранша дава възможност бързо и качествено да представим идеите Ви реализирани.
      <br><br>
    <i class="fa fa-info-circle" aria-hidden="true"></i> Ако сте собственик на заведение, доставчик на храни и напитки, маркетингова агенция или просто искате да имате рекламно каре, линк или друго присъствие на страниците на Zavedenia.	com и/ или всички други сайтове от групата на © Zavedenia.bg, може да се свържете с нас на следния телефони: <b class="bold">0888123474</b> <br>
    Може да ни пишете на <a href="mailto:atanas@zavedenia.bg">gerogid&#64;zavedenia.com</a>.<br><br>

    Повече информация за актуални условия и цени: <a href="https://sofia.zavedenia.com/login/page/banners/" title="Заведения София, Пловдив, Варна - реклама"> РЕКЛАМА НА САЙТА</a>





    <br><br>

    </p>
  </div>

  <div data-language="mk" *ngIf="selectedLang === 'mk'">
    <h1>Можности за реклама &#64; Zavedenia.bg</h1>
    <h2>Платена реклама за целосна промоција на ресторани, барови, клубови</h2>

    <p>Дополнителната реклама на веб-страницата, надвор од абонаментските пакети, може да го зголеми бројот на посетители на вашиот профил и потенцијалните клиенти во вашето угостителско објект.<br>
      Ќе ви помогнеме да изработите соодветна маркетинг стратегија за конкретен настан или тип на локал. Нашето долгогодишно искуство во индустријата ни овозможува брзо и квалитетно да ги реализираме вашите идеи.
      <br><br>
      <i class="fa fa-info-circle" aria-hidden="true"></i> Доколку сте сопственик на локал, добавувач на храна и пијалаци, маркетинг агенција или едноставно сакате да имате рекламно поле, линк или друго присуство на страниците на Zavedenia.com и/или другите сајтови од групацијата на © Zavedenia.bg, можете да не контактирате на следниов телефон: <b class="bold">0888123474</b><br>
      Можете да ни пишете на <a href="mailto:atanas@zavedenia.bg">gerogid&#64;zavedenia.com</a>.<br><br>

      Повеќе информации за тековни услови и цени: <a href="https://sofia.zavedenia.com/login/page/banners/" title="Заведения София, Пловдив, Варна - реклама">РЕКЛАМА НА ВЕБ-СТРАНИЦАТА</a>

      <br><br>
    </p>
  </div>
  <div data-language="sr" *ngIf="selectedLang === 'sr'">
    <h1>Mogućnosti za reklamu &#64; Zavedenia.bg</h1>
    <h2>Plaćeno oglašavanje za celokupno predstavljanje restorana, barova, klubova</h2>

    <p>Dodatna reklama na sajtu, van pretplatničkih paketa, može povećati broj posetilaca vašeg profila i potencijalne goste u vašem lokalu.<br>
      Pomoći ćemo vam da osmislite odgovarajuću marketinšku strategiju za određenu priliku ili tip lokala. Naše dugogodišnje iskustvo u industriji omogućava brzo i kvalitetno sprovođenje vaših ideja.
      <br><br>
      <i class="fa fa-info-circle" aria-hidden="true"></i> Ako ste vlasnik lokala, dobavljač hrane i pića, marketinška agencija ili jednostavno želite da imate reklamni prostor, link ili drugo prisustvo na stranicama Zavedenia.com i/ili ostalim sajtovima iz grupe © Zavedenia.bg, možete nas kontaktirati na sledeći broj: <b class="bold">0888123474</b><br>
      Možete nam pisati na <a href="mailto:atanas@zavedenia.bg">gerogid&#64;zavedenia.com</a>.<br><br>

      Više informacija o aktuelnim uslovima i cenama: <a href="https://sofia.zavedenia.com/login/page/banners/" title="Zavedenia Sofija, Plovdiv, Varna - reklama">REKLAMA NA SAJTU</a>

      <br><br>
    </p>
  </div>


  </div>
  </div>
</div>
